const config = {
  imgBaseUrl: process.env.NEXT_PUBLIC_IMAGES_BASE_URL,
  apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL || "",
  googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || "",
  openWeatherAppId: process.env.NEXT_PUBLIC_OPEN_WEATHER_APP_ID,
};

export default config;
